import endClientSession from './endClientSession';
import { getEntryPoint } from './getEntryPoint';

export const loginEndSessionEntryPoint = ({ dispatch, getState }) => async (nextState, replace, callback) => {
  const isDynaTraceScriptLoaded = () => document.querySelector('script[src*="dynatrace"]');

  if (global.BROWSER) {
    endClientSession({ dispatch, getState });
    getEntryPoint();
    // maximum interval of 15 seconds
    let elapsed = 0;
    const intervalId = setInterval(() => {
      if (isDynaTraceScriptLoaded()) {
        window.dtrum.endSession();
        clearInterval(intervalId);
      }
      elapsed += 1000;
      if (elapsed >= 15000) {
        clearInterval(intervalId);
      }
    }, 1000);
  }
  callback();
};
